import { Link } from "react-router-dom";
import "./PortfolioStyle.css";
const ProjectCard = ({
  id,
  title,
  image,
  description,
  technologies,
  url,
  githubUrl,
}) => {
  return (
    <div className="col-lg-4 col-md-6 mb-4 project-card-container">
      <div className="project-card">
        {/* Image with overlay */}
        <div className="project-image-container">
          <img src={image} alt={title} className="project-image" />
          <div className="image-overlay">
            <div className="button-group">
              <Link
                to={url}
                target="_blank"
                rel="noopener noreferrer"
                className="action-button demo"
              >
                <i className="fa fa-external-link-alt"></i> Live Demo
              </Link>
              {githubUrl && (
                <Link
                  to={githubUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="action-button code"
                >
                  <i className="fa fa-code"></i> Code
                </Link>
              )}
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="card-content">
          {id === "featured" && (
            <span className="featured-tag">
              <i className="fa fa-star"></i> Featured
            </span>
          )}
          <h3 className="card-title">{title}</h3>
          <p className="card-description">{description}</p>

          {/* Technologies */}
          <div className="tech-container">
            <div className="tech-label">
              <i className="fa fa-cogs"></i> Technologies:
            </div>
            <div className="tech-items">
              {technologies &&
                technologies.map((tech, index) => (
                  <span key={index} className="tech-item">
                    {tech}
                  </span>
                ))}
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="card-footer">
          <Link to={url} target="_blank" className="explore-link">
            Explore Project <i className="fa fa-chevron-right"></i>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ProjectCard;
